// VEPC Gestao - Central Administrativa: Ponto de Entrada SPA
import { state, setOperador, initOperador, OPERADORES_DEMO, isAmbienteProducao } from './api.js';
import { logoutProprietarioFirebase } from './firebase.js';
import { renderDashboard } from './views/DashboardView.js';
import { renderEmpresas } from './views/EmpresasView.js';
import { renderPlanos } from './views/PlanosView.js';
import { renderMensalidades } from './views/MensalidadesView.js';
import { renderInfra } from './views/InfraView.js';
import { renderSuporte } from './views/SuporteView.js';
import { renderOperadores } from './views/OperadoresView.js';
import { renderOnboarding } from './views/OnboardingView.js';
import { renderLoginAdmin } from './views/LoginAdminView.js';

initOperador();

const VIEWS = {
  dashboard: { titulo: 'Dashboard Geral', render: renderDashboard },
  empresas: { titulo: 'Empresas Clientes & Clientes Beta', render: renderEmpresas },
  planos: { titulo: 'Planos Comerciais & Módulos', render: renderPlanos },
  mensalidades: { titulo: 'Mensalidades & Conferência', render: renderMensalidades },
  infra: { titulo: 'Aplicativo & Infraestrutura', render: renderInfra },
  suporte: { titulo: 'Suporte & Erros', render: renderSuporte },
  operadores: { titulo: 'Operadores & Auditoria', render: renderOperadores }
};

function renderApp() {
  const app = document.getElementById('app');

  // 1. Roteamento inteligente: Onboarding vs Painel Administrativo
  const path = window.location.pathname.toLowerCase();
  const search = new URLSearchParams(window.location.search);
  const isOnboarding = path.includes('/onboarding') || search.has('token');

  if (isOnboarding) {
    app.innerHTML = `
      <div class="onboarding-wrapper">
        <div class="spinner"></div>
      </div>
    `;
    renderOnboarding().then(element => {
      app.innerHTML = '';
      app.appendChild(element);
    }).catch(err => {
      app.innerHTML = `
        <div class="onboarding-wrapper">
          <div class="onboarding-card">
            <div class="onboarding-error-box">
              <div class="error-icon">⚠️</div>
              <h3 class="error-title">Erro ao carregar primeiro acesso</h3>
              <p class="error-message">${err.message}</p>
              <a href="/" class="btn btn-secondary">Voltar ao Painel</a>
            </div>
          </div>
        </div>
      `;
    });
    return;
  }

  // 2. Bloqueio e Login do Proprietário em Produção (Firebase Auth)
  const tokenAutenticado = typeof localStorage !== 'undefined' ? localStorage.getItem('vepc_admin_firebase_token') : null;
  if (isAmbienteProducao() && !tokenAutenticado) {
    app.innerHTML = '';
    app.appendChild(renderLoginAdmin());
    return;
  }

  // 3. Layout Principal da Central Administrativa Dark Premium
  app.innerHTML = `
    <div class="app-layout">
      <!-- Sidebar -->
      <aside class="sidebar">
        <div class="sidebar-header">
          <div class="brand-wrapper">
            <div class="brand-icon">V</div>
            <div class="brand-text">
              <h1>VEPC Gestão</h1>
              <span>Central Administrativa</span>
            </div>
          </div>
        </div>

        <nav class="sidebar-nav">
          <a class="nav-item ${state.viewAtual === 'dashboard' ? 'active' : ''}" data-view="dashboard">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
            Dashboard
          </a>
          <a class="nav-item ${state.viewAtual === 'empresas' ? 'active' : ''}" data-view="empresas">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            Empresas & Beta
          </a>
          <a class="nav-item ${state.viewAtual === 'planos' ? 'active' : ''}" data-view="planos">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>
            Planos & Módulos
          </a>
          <a class="nav-item ${state.viewAtual === 'mensalidades' ? 'active' : ''}" data-view="mensalidades">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
            Mensalidades
          </a>
          <a class="nav-item ${state.viewAtual === 'infra' ? 'active' : ''}" data-view="infra">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/></svg>
            App & Infraestrutura
          </a>
          <a class="nav-item ${state.viewAtual === 'suporte' ? 'active' : ''}" data-view="suporte">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            Suporte & Erros
          </a>
          <a class="nav-item ${state.viewAtual === 'operadores' ? 'active' : ''}" data-view="operadores">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            Operadores & Auditoria
          </a>
        </nav>

        <div class="sidebar-footer">
          <div class="beta-seal">
            ⭐ GARANTIA BETA ATIVA
          </div>
          <div>VEPC Soluções Digitais &bull; v0.1.0</div>
          <div style="font-size: 10px; color: #64748B; margin-top: 2px;">
            ${isAmbienteProducao() ? 'Produção Oficial &bull; v0.1.0' : 'Ambiente Local de Homologação'}
          </div>
        </div>
      </aside>

      <!-- Área de Conteúdo -->
      <main class="main-wrapper">
        <!-- Topbar -->
        <header class="topbar">
          <div class="topbar-left">
            ${isAmbienteProducao() ? `
              <div class="env-banner" style="background: rgba(16, 185, 129, 0.15); border: 1px solid rgba(16, 185, 129, 0.35); color: #6EE7B7;">
                <span class="env-indicator" style="background: #10B981;"></span>
                PAINEL OFICIAL &bull; VEPC GESTÃO
              </div>
              <span style="font-size: 13px; color: var(--vepc-text-muted);">
                Central Administrativa do Proprietário
              </span>
            ` : `
              <div class="env-banner">
                <span class="env-indicator"></span>
                AMBIENTE LOCAL &bull; DADOS DEMO
              </div>
              <span style="font-size: 13px; color: var(--vepc-text-muted);">
                Cobranças e bloqueios automáticos desativados
              </span>
            `}
          </div>

          <div class="topbar-right">
            <div class="operator-card">
              <div class="operator-avatar">
                ${state.operadorAtivo.nome.charAt(0)}
              </div>
              <div class="operator-info">
                <span class="operator-name">${state.operadorAtivo.nome}</span>
                <span class="operator-role">${state.operadorAtivo.rotulo}</span>
              </div>
              ${!isAmbienteProducao() && !tokenAutenticado ? `
                <select id="select-operador" class="operator-select" title="Trocar perfil de teste administrativo">
                  ${OPERADORES_DEMO.map(op => `
                    <option value="${op.id}" ${op.id === state.operadorAtivo.id ? 'selected' : ''}>
                      ${op.rotulo}
                    </option>
                  `).join('')}
                </select>
              ` : `
                <button id="btn-admin-logout" class="btn btn-secondary" style="margin-left: 10px; padding: 6px 12px; font-size: 12px; border-radius: 6px;" title="Encerrar sessão administrativa">
                  Sair
                </button>
              `}
            </div>
          </div>
        </header>

        <!-- Container da Tela Atual -->
        <div id="view-container"></div>
      </main>
    </div>
  `;

  // Eventos de Navegação
  app.querySelectorAll('.nav-item').forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const targetView = item.dataset.view;
      if (VIEWS[targetView]) {
        state.viewAtual = targetView;
        renderApp();
      }
    });
  });

  // Seletor de Operador Demo (apenas em ambiente local sem Firebase)
  const selectOp = app.querySelector('#select-operador');
  if (selectOp) {
    selectOp.addEventListener('change', (e) => {
      setOperador(e.target.value);
      renderApp();
    });
  }

  // Logout do Proprietário
  const btnLogout = app.querySelector('#btn-admin-logout');
  if (btnLogout) {
    btnLogout.addEventListener('click', async () => {
      await logoutProprietarioFirebase();
      renderApp();
    });
  }

  // Renderiza a view atual
  const viewContainer = app.querySelector('#view-container');
  const viewRenderer = VIEWS[state.viewAtual].render;
  viewRenderer().then(element => {
    viewContainer.innerHTML = '';
    viewContainer.appendChild(element);
  });
}

// Eventos customizados
window.addEventListener('vepc:admin_logado', () => {
  renderApp();
});

window.addEventListener('vepc:sessao_expirada', () => {
  const app = document.getElementById('app');
  app.innerHTML = '';
  app.appendChild(renderLoginAdmin('Sua sessão expirou por segurança. Por favor, faça login novamente.'));
});

window.addEventListener('vepc:navegar', (e) => {
  if (VIEWS[e.detail]) {
    state.viewAtual = e.detail;
    renderApp();
  }
});

window.addEventListener('popstate', () => {
  renderApp();
});

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href="/"]');
  if (link) {
    e.preventDefault();
    window.history.pushState(null, '', '/');
    renderApp();
  }
});

renderApp();
